var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._b({attrs:{"label":_vm.computedLabel,"items":_vm.$t('countries'),"value":_vm.value,"rules":_vm.rules},on:{"input":_vm.updateValue}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }